import { DEX_TYPE } from "@/config/constants";
import { getEnvAndDex } from "@/utils/get-env-and-dex";

export const useBuildex = () =>{
	const { dex } = getEnvAndDex();

	const isBuildex = DEX_TYPE.SGBUILDEX === dex;
	return isBuildex;
}
